import { useEffect, useState } from 'react';
import axios from 'axios';

interface Chat {
    [x: string]: any;
    user_id: string;
}

const useUserChats = (userId: string) => {
    const [chats, setChats] = useState<Chat[]>([]);

    useEffect(() => {
        const fetchChats = async () => {
            const user_id = encodeURIComponent(userId);
            //const session_id = encodeURIComponent('test1');
            const apiUrl = `http://34.94.96.59:5050/infindbot/get_history`;
            
            try {
                const response = await axios.get(apiUrl, {
                    params: {
                      user_id: user_id,
                    },
                    headers: {
                      'Content-Type': 'application/json',
                    },
                });

                const projectArray = response.data.content
                ? Object.values(response.data.content) as Chat[]
                : [];

                if (response.data.content) {
                    setChats(projectArray);
                } 
            } catch (error:any) {
                console.error('Error fetching chats:', error.message);
            }
        };
        fetchChats();
    }, [userId]); // Add userEmail as a dependency
    return chats;
};
export default useUserChats;